import React from 'react';
import {Card, Col, FormCheck, Row} from "react-bootstrap";
import {Glyph} from "./Glyph";

export default class CollapsibleMultiSelect extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            collapsed: true
        }
    }

    toggle = () => {
        this.setState({collapsed: !this.state.collapsed});
    }

    itemToggled = (e, item) => {
        if (e.target.checked) {
            this.props.itemSelected(item);
        } else {
            this.props.itemDeselected(item);
        }
    }

    render() {
        let vk = this.props.valueKey || "value";
        let lk = this.props.labelKey || "label";
        let selectedItems = this.props.selectedItems || [];

        return <Card>
            <Card.Body>
                <Row className={"clickable"} onClick={this.toggle}>
                    <Col style={{textOverflow: "ellipsis"}}>
                        <Glyph name={this.state.collapsed ? "chevron-right" : "chevron-down"} className={"mr-2"}/>
                        <i>{selectedItems.length} selected</i>
                    </Col>
                </Row>
                <Row className={this.state.collapsed ? "d-none" : ""}>
                    <Col>
                        {this.props.items && this.props.items.map(item => <Row key={item[vk]}>
                            <Col>
                                <FormCheck label={item[lk]} onChange={(e) => this.itemToggled(e, item)} checked={selectedItems.includes(item)}/>
                            </Col>
                        </Row>)}
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    }
}